import { lazy, Suspense } from "react";
import Loader from '../custom/loader/main';

const Main = lazy(() => import('../components/forgotPassword/main'))

const ForgotPassword = () =>{
return(
    <Suspense fallback={<Loader/>}>
        <Main/>
    </Suspense>
)
   
 

}

export default ForgotPassword;